import { useState, useContext, createContext, useEffect } from "react";

const homeContext = createContext();

export const useHomeContext = () => useContext(homeContext);

export const HomeProvider = ({ children }) => {
  const [readNotificationId, setReadNotificationId] = useState(null);
  const [readAllNotificationId, setAllReadNotificationId] = useState(null);
  const [activeMenu, setActiveMenu] = useState(true);
  const [currentMode, setCurrentMode] = useState("Light");
  const [screenSize, setScreenSize] = useState(undefined);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [propertyId, setPropertyId] = useState(null);
  const setMode = (mode) => {
    setCurrentMode(mode);
    localStorage.setItem("themeMode", mode);
  };

  const handleNav = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
      setIsSmallScreen(true);
      setIsOpen(false);
    } else {
      setActiveMenu(true);
      setIsSmallScreen(false);
    }
  }, [screenSize]);

  const toogleActiveMenu = () => {
    setActiveMenu((prevActiveMenu) => !prevActiveMenu);
  };
  return (
    <homeContext.Provider
      value={{
        handleNav,
        activeMenu,
        setActiveMenu,
        screenSize,
        currentMode,
        setMode,
        setCurrentMode,
        isSmallScreen,
        setIsSmallScreen,
        toogleActiveMenu,
        isOpen,
        setIsOpen,
        propertyId,
        setPropertyId,
        readNotificationId,
        setReadNotificationId,
        readAllNotificationId,
        setAllReadNotificationId,
      }}
    >
      {children}
    </homeContext.Provider>
  );
};
